module.exports = __webpack_public_path__ + "631004dc63fa17cd1d6d209121158744.svg";